module.exports = __webpack_public_path__ + "img/LqyellowTs.65b624e1.svg";